import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ActivityFrame } from '@/features/activity/frame';

// S17–S20: the Activity title, the tab's lead and the tabs around the tab's route.
export const Route = createFileRoute('/_app/activity')({
  component: () => (
    <ActivityFrame>
      <Outlet />
    </ActivityFrame>
  ),
});
